import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { Observable } from 'rxjs';

export type ShiftId = string;
export interface Productivity {
  productiveMinutes: number;
  totalMinutes: number;
  productivityRatio: number;
}

export interface ProductivitiesResponse {
  usersProductivities: Record<string, Productivity>;
  overallProductivity: Productivity;
}

@Injectable({
  providedIn: 'root',
})
export class ProductivityKPIGatewayService {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject<ConfigOptions>(ConfigService);

  protected readonly path = 'v1/kpis';

  getProductivities(
    userIds: string[],
    timeRange: {
      startDatetime: string;
      endDatetime: string;
    },
  ): Observable<ProductivitiesResponse> {
    return this.httpClient.post<ProductivitiesResponse>(
      `${this.config.host}/${this.path}/productivities`,
      {
        userIds,
        from: timeRange.startDatetime,
        to: timeRange.endDatetime,
      },
    );
  }
}
